<template>
  <footer class="footer">
    <div class="footer-content">
      <p class="footer-info">
        <span class="footer-item">&copy; 2026 Sportemocracy Srls. All rights reserved.</span>
        <span class="divisore" aria-hidden="true">|</span>
        <span class="footer-item">P. IVA: 03301520213</span>
        <span class="divisore" aria-hidden="true">|</span>
        <span class="footer-item">
          Contatto:
          <a href="mailto:info@sportemocracy.it" class="footer-mail">info@sportemocracy.it</a>
        </span>
      </p>
      <div class="footer-social">
        <span class="footer-social-label">Seguici</span>
        <a href="https://www.instagram.com/sportemocracy/" target="_blank" rel="noopener noreferrer" aria-label="Sportemocracy su Instagram">
          <img src="/icons/instagram.svg" alt="Instagram" width="24" height="24" />
        </a>
        <a href="https://www.linkedin.com/company/sportemocracy/" target="_blank" rel="noopener noreferrer" aria-label="Sportemocracy su LinkedIn">
          <img src="/icons/linkedin.svg" alt="LinkedIn" width="24" height="24" />
        </a>
      </div>
      <nav class="footer-links">
        <ul>
          <li><router-link to="/legal/cookie">Cookie Policy</router-link></li>
          <li><router-link to="/legal/privacy">Privacy Policy</router-link></li>
          <li><a href="#" @click.prevent="openCookiePreferences">Preferenze cookie</a></li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    openCookiePreferences() {
      if (typeof window === 'undefined') {
        return;
      }
      var popup = window.__cookieconsentPopup;
      if (popup && typeof popup.open === 'function') {
        popup.open();
      } else if (popup && typeof popup.revokeChoice === 'function') {
        popup.revokeChoice();
      } else if (window.cookieconsent && typeof window.cookieconsent.open === 'function') {
        window.cookieconsent.open();
      } else if (window.cookieconsent && typeof window.cookieconsent.show === 'function') {
        window.cookieconsent.show(true);
      }
      var sync = window.__syncCookieBannerSpacing;
      if (typeof sync === 'function') {
        sync();
        setTimeout(sync, 50);
      }
    }
  }
}
</script>

<style lang="scss"  scoped>
@import "@/assets/styles/colors.scss";
.footer {
  background-color: $primary;
  color: $white;
  padding: 22px 16px;
  padding-left: max(16px, env(safe-area-inset-left, 0px));
  padding-right: max(16px, env(safe-area-inset-right, 0px));
  padding-bottom: calc(22px + max(var(--cookie-banner-space), env(safe-area-inset-bottom, 0px)));
  text-align: left;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.7;
  width: 100%;
}

.footer-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-links {
  margin-top: 0;
  font-size: 1rem;
  line-height: 1.2;
}

.footer-mail {
  color: $white;
  text-decoration: underline;
  word-break: break-all;
}

.footer-mail:hover {
  color: $primary-light;
}

.footer nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  align-items: center;
}

.footer nav ul li {
  margin: 0;
}

.footer nav ul li a {
  color: $white;
  text-decoration: none;
  white-space: nowrap;
}

.footer nav ul li a:hover {
  color: $primary-light; 
}

.footer-info {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-wrap: anywhere;
}

.footer-item {
  display: block;
}

.divisore {
  display: none;
  margin: 0 10px;
  color: $white;
}

.footer-mail:focus-visible,
.footer nav ul li a:focus-visible {
  outline: 2px solid $neutral-light;
  outline-offset: 3px;
  border-radius: 4px;
}

@media (min-width: 900px) and (orientation: landscape) {
  .footer {
    padding: 24px 24px;
    padding-bottom: calc(24px + max(var(--cookie-banner-space), env(safe-area-inset-bottom, 0px)));
    font-size: 1rem;
    line-height: 1.5;
  }

  .footer-content {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    column-gap: 48px;
    align-items: center;
  }

  .footer-info {
    grid-column: 1;
    justify-self: start;
    gap: 4px;
  }

  .footer-social {
    grid-column: 2;
    justify-self: center;
  }

  .footer-links {
    grid-column: 3;
    justify-self: end;
    font-size: 0.95rem;
  }

  .footer nav ul {
    gap: 18px;
  }
}

.footer-social {
  display: flex;
  gap: 16px;
  align-items: center;
}

.footer-social-label {
  font-size: 1rem;
  color: $white;
}

.footer-social a {
  display: flex;
  align-items: center;
}

.footer-social img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
  transition: opacity 0.15s;
}

.footer-social a:hover img {
  opacity: 0.7;
}

.footer-social a:focus-visible {
  outline: 2px solid $neutral-light;
  outline-offset: 3px;
  border-radius: 4px;
}

@media (max-width: 480px) {
  .footer-links {
    font-size: 0.95rem;
  }

  .footer nav ul {
    gap: 8px;
  }
}

@media (max-width: 360px) {
  .footer-links {
    font-size: 0.9rem;
  }

  .footer nav ul {
    gap: 6px;
  }
}
</style>
